import { flatten } from './flatten'
import enDict from './en'
import zhDict from './zh-CN'

export const messages = {
  en: flatten(enDict),
  'zh-CN': flatten(zhDict)
}

export type Locale = 'en' | 'zh-CN'
export type MessageKey = keyof typeof messages.en

const LOCALE_STORAGE_KEY = 'app_locale'

function resolveLocale(): Locale {
  const stored = localStorage.getItem(LOCALE_STORAGE_KEY)
  if (stored === 'zh-CN' || stored === 'en') {
    return stored
  }
  return 'en'
}

function interpolate(template: string, params: Record<string, string | number>): string {
  return template.replace(/\{(\w+)\}/g, (_, key) => String(params[key] ?? `{${key}}`))
}

/**
 * 非 Vue 上下文使用的翻译函数（如 Axios 拦截器）
 */
export function translate(key: MessageKey, params?: Record<string, string | number>): string {
  const locale = resolveLocale()
  const msg = messages[locale][key] || messages.en[key]
  return params && msg ? interpolate(msg, params) : (msg || key)
}
